// Herbalife disclosure popup (James Simon Bennett) – Neil style
(function () {
  const STORAGE_KEY = "herbalife_popup_ack_v1";
  const NAME = "James Simon Bennett";

  function buildPopup() {
    return `
<style>
  #herbalifepopup{position:fixed;inset:0;z-index:999999;display:none}
  #herbalifepopup .hl-bg{position:absolute;inset:0;background:rgba(0,0,0,.6)}
  #herbalifepopup .hl-box{
    position:relative;background:#fff;max-width:520px;width:92%;
    margin:10vh auto 0;padding:22px 20px;border-radius:10px;
    font-family:Helvetica,Arial,sans-serif;color:#6c6d70;text-align:left;
    box-shadow:0 10px 40px rgba(0,0,0,.25)
  }
  #herbalifepopup h1{margin:0 0 10px;font-size:1.3rem;font-weight:700;color:#6c6d70}
  #herbalifepopup p{margin:0 0 10px;line-height:1.45;font-size:.98rem;color:#6c6d70}
  #herbalifepopup .hl-actions{display:flex;gap:10px;justify-content:flex-end;flex-wrap:wrap;margin-top:14px}
  #herbalifepopup .hl-btn{
    border:1px solid #6c6d70;background:#fff;color:#6c6d70;
    border-radius:8px;padding:10px 14px;font-weight:700;cursor:pointer;font-size:.95rem
  }
  #herbalifepopup .hl-btn.primary{background:#6c6d70;color:#fff}
  #herbalifepopup .hl-small{font-size:.86rem;opacity:.9;margin-top:6px}
</style>

<div class="hl-bg" aria-hidden="true"></div>
<div class="hl-box" role="dialog" aria-modal="true" aria-labelledby="hlTitle">
  <h1 id="hlTitle">Important information</h1>
  <p>This website is operated by an <strong>Independent Herbalife Distributor</strong>.</p>
  <p>The distributor for this website is <strong>James Bennett</strong>.</p>
  <p>If you already have an Independent Herbalife Distributor, you may prefer to place your order directly through them.</p>
  <p class="hl-small">By continuing, you confirm you understand this information.</p>
  <div class="hl-actions">
    <button type="button" class="hl-btn" id="hlExit">Leave site</button>
    <button type="button" class="hl-btn primary" id="hlContinue">Continue</button>
  </div>
</div>
`;
  }

  function show() {
    const el = document.getElementById("herbalifepopup");
    if (!el) return;

    el.innerHTML = buildPopup();
    el.style.display = "block";
    document.documentElement.style.overflow = "hidden";

    const exitBtn = document.getElementById("hlExit");
    const continueBtn = document.getElementById("hlContinue");

    function close() {
      el.style.display = "none";
      document.documentElement.style.overflow = "";
      localStorage.setItem(STORAGE_KEY, "1");
    }

    continueBtn && continueBtn.addEventListener("click", close);

    exitBtn && exitBtn.addEventListener("click", function () {
      try {
        if (window.history.length > 1) window.history.back();
        else window.location.href = "https://www.google.com/";
      } catch (e) {
        window.location.href = "https://www.google.com/";
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) show();
    } catch (e) {
      // If storage is blocked, still show once per load
      show();
    }
  });
})();
